{
  "moreActions": "Mai multe acțiuni",
  "unavailable": "Indisponibil, extindeți pentru detalii"
}
